import * as views from "../views";
import EmptyView from "@/core/components/EmptyView.vue";
import { i18nFormat } from "@/i18n.js";

export default [
  {
    path: "account",
    component: EmptyView,
    meta: {
      headerVisible: false
    },
    children: [
      {
        path: "settings",
        name: "AccountSettings",
        component: views.Settings,
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("tc", "generals.setting", 2),
          headerDescription: i18nFormat("t", "accountSettings.headerDesc"),
          headerDomain: null,
          allowAutoSidebar: true
        }
      },
    ]
  }
];
